import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

function PdfSvg(props) {
    const finalProps = {
        ...props,
        viewBox: '-4 -3 40 40',
    };
    return (
        <SvgIcon {...finalProps}>
            <g>
                <path
                    d="M13.2,12.3c0.2,1.8,0.3,5.1-1.1,7.8c-0.1,0.2-0.2,0.4-0.3,0.6c-2.3,0.7-4.8,2.1-5.2,3.6c-0.2,0.6,0,1.2,0.4,1.6
                    c0.4,0.5,1,0.7,1.6,0.7c1.4,0,2.9-1.4,4.6-4.2c0.6-0.1,4-0.6,4.7-0.6c2,2,3.6,3,4.9,3c0.8,0,1.5-0.4,1.9-1.1
                    c0.3-0.5,0.3-1.1,0-1.6c-0.8-1.5-4-2.1-5.9-2.2c-0.2-0.2-0.3-0.4-0.5-0.6c-2-2.2-2.8-5.5-3-7.2c0-0.4-0.1-0.7-0.1-1
                    c-0.1-0.9-0.7-1-1-1c-0.3,0-0.6,0.1-0.7,0.3c-0.3,0.3-0.3,0.7-0.2,1C13.1,11.7,13.1,12,13.2,12.3z M8.6,24.6
                    c0.2-0.2,0.6-0.5,1.1-0.8C9.2,24.3,8.8,24.5,8.6,24.6z M22.5,22.9c-0.2,0-0.5-0.1-1-0.4C22,22.6,22.3,22.7,22.5,22.9z M14.9,17.9
                    c0.4,0.7,0.8,1.4,1.2,2c-0.2,0-1.8,0.2-1.9,0.2C14.5,19.5,14.7,18.7,14.9,17.9z"
                />
                <path d="M11.1,0L3,8.5v22.7h25.3V0H11.1z M10.4,3.6v3.8H6.8L10.4,3.6z M26.3,29.3H4.9v-20h7.4V2h14L26.3,29.3L26.3,29.3z" />
            </g>
        </SvgIcon>
    );
}

export default PdfSvg;
